import React from 'react';
import { Linkedin, Instagram, Youtube } from 'lucide-react';
import { LOGO } from '../media';
import { CONTACT_EMAIL, CONTACT_HREF } from '../content';

/* ===========================================================================
   ENTITY DETAILS  <<<  CONFIRM BEFORE ANY PUBLIC LAUNCH  >>>
   ---------------------------------------------------------------------------
   The Lovable build had no address, no email, no EIN, no tax-deductibility
   language and no privacy policy anywhere. For an organization asking for
   gifts, that is the first thing a careful donor looks for, and most states
   impose charitable solicitation disclosure requirements on top.

   Everything marked TODO below is a placeholder. Do not launch with them.
   Whether the 501(c)(3) line can be used at all depends on the Foundation's
   actual formation and determination status, which is a question for counsel,
   not for this file.
   =========================================================================== */

const ENTITY = {
  legalName: 'Vitality Foundation',
  // TODO confirm exact registered name
  address: ['Denver, CO'],
  ein: null as string | null,
  // TODO e.g. '00-0000000'
  taxStatus: null as string | null // TODO e.g. 'a 501(c)(3) tax-exempt organization'
};
const SOCIAL = [{
  label: 'Vitality Foundation on LinkedIn',
  href: null as string | null,
  Icon: Linkedin
}, {
  label: 'Vitality Foundation on Instagram',
  href: null as string | null,
  Icon: Instagram
}, {
  label: 'Vitality Foundation on YouTube',
  href: null as string | null,
  Icon: Youtube
}];
const LINKS = [{
  label: 'Our Mission',
  href: '#mission'
}, {
  label: 'Five Essentials',
  href: '#essentials'
}, {
  label: 'How It Works',
  href: '#how'
}, {
  label: 'Support Us',
  href: '#support'
}, {
  label: 'Get In Touch',
  href: CONTACT_HREF
}];
export function SiteFooter() {
  return <footer className="theme-dark border-t border-border/40 bg-background text-foreground" data-id="element-190" data-mp="27ee8mx33lt87">
      <div className="section-shell py-14" data-id="element-191" data-mp="2c8s5z51bmafi">
        <div className="grid gap-12 md:grid-cols-[1.2fr_1fr_1fr]" data-id="element-192" data-mp="2m3603oi2c9ly">
          <div data-id="element-193" data-mp="2h3tflaenzemj">
            <img src={LOGO} alt="Vitality Foundation" className="h-16 w-auto max-w-56 object-contain" data-id="element-194" data-mp="2h3be9zd5aa7r" />
            <p className="mt-6 max-w-xs text-body-sm leading-body text-muted-foreground" data-id="element-195" data-mp="2d1gcktraxutg">
              A living innovation system.
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-196" data-mp="285hg0ivtl6hy">
            <h2 className="overline text-foreground" data-id="element-197" data-mp="234bnal25tj8f">Explore</h2>
            <ul className="mt-5 space-y-3 text-body-sm" data-id="element-198" data-mp="235wfw54wys3n">
              {LINKS.map(l => <li key={l.href} data-id="element-199" data-mp="1yc0ppouw69j1">
                  <a href={l.href} className="hover:text-accent" target={l.href.startsWith('http') ? '_blank' : undefined} rel={l.href.startsWith('http') ? 'noopener noreferrer' : undefined} data-id="element-200" data-mp="1tdz5v1pn666i">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-201" data-mp="1feha22dxhsnn">
            <h2 className="overline text-foreground" data-id="element-202" data-mp="1fdxuutfnxidb">Contact</h2>
            <address className="mt-5 space-y-2 text-body-sm not-italic text-muted-foreground" data-id="element-203" data-mp="1fgtquc7y9wz4">
              <p data-id="element-204" data-mp="3r3xczxzmf9vo">{ENTITY.legalName}</p>
              {ENTITY.address.map(line => <p key={line} data-id="element-205" data-mp="3vzmalvs2ygpc">{line}</p>)}
              <p data-id="element-206" data-mp="3w2qq3pazwyvb">
                <a href={`mailto:${CONTACT_EMAIL}`} className="text-accent hover:underline" data-id="element-207" data-mp="4uw2xlxnesua">
                  {CONTACT_EMAIL}
                </a>
              </p>
            </address>

            {/* FIXED: these were bare icons in the Lovable build, not links.
                A social icon that is not a link is decoration pretending to be
                navigation. Any without a URL is simply not rendered. */}
            <div className="mt-6 flex gap-4" data-id="element-208" data-mp="3hbrh4d6908b7">
              {SOCIAL.filter(s => s.href).map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href!} aria-label={label} target="_blank" rel="noopener noreferrer" className="rounded-md p-1 hover:text-accent" data-id="element-209" data-mp="3m4ufcylz05xq">
                  <Icon size={18} aria-hidden="true" data-id="element-210" data-mp="2tlneo94sqels" />
                </a>)}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-3 border-t border-border pt-6 text-caption text-muted-foreground sm:flex-row" data-id="element-211" data-mp="2ailou8zwuqst">
          <p data-id="element-212" data-mp="2k7n1bp78yq21">&copy; {new Date().getFullYear()} {ENTITY.legalName}. All rights reserved.</p>
          {ENTITY.ein && ENTITY.taxStatus && <p data-id="element-213" data-mp="2fgdd8t1cjus9">{`${ENTITY.legalName} is ${ENTITY.taxStatus}. EIN ${ENTITY.ein}.`}</p>}
        </div>
      </div>
    </footer>;
}